module.exports = __webpack_public_path__ + "img/fondo2.ff1b64f4.jpg";